// extracted by mini-css-extract-plugin
module.exports = {"flexBetween":"newProductModalStyle_flexBetween__17jiy","colsStyle":"newProductModalStyle_colsStyle__3oXsp","width100":"newProductModalStyle_width100__1Tn7h"};